import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import { CalendarCheck, Link2, StickyNote, Tag } from "lucide-react";
import { errore, stileEtichetta } from "./crmComuni";

// Sprint CRM-2B — riga in fondo alla scheda in colonna: icone Note / Attività / URL e le etichette. Il clic qui NON apre la scheda
function Icona({ attiva, titolo, n, onClick, testid, children }) {
  return (
    <button type="button" title={titolo} disabled={!attiva} onClick={onClick} data-testid={testid}
      className={`relative inline-flex h-6 w-6 items-center justify-center rounded ${attiva ? "text-sky-600 hover:bg-sky-50" : "text-slate-300 cursor-default"}`}>
      {children}
      {n > 0 && <span className="absolute -top-1 -right-1 min-w-[14px] h-3.5 px-0.5 rounded-full bg-sky-500 text-white text-[9px] leading-[14px]">{n}</span>}
    </button>
  );
}

export default function RigaIcone({ o, etichette, onCambio }) {
  const nav = useNavigate();
  const mie = o.etichette || [];
  const aggiungibili = etichette.filter((e) => !e.archiviata || mie.includes(e.id));
  const cambia = async (id) => {
    const nuove = mie.includes(id) ? mie.filter((x) => x !== id) : [...mie, id];
    try { await api.put(`/crm/opportunita/${o.id}`, { etichette: nuove }); onCambio(); } catch (e) { toast.error(errore(e)); }
  };
  return (
    <div className="flex items-center justify-between gap-2 pt-1 border-t border-slate-100 cursor-default" onClick={(e) => e.stopPropagation()}
      data-testid={`crm-scheda-icone-${o.id}`}>
      <div className="flex gap-3">
        <Icona attiva={o.n_note > 0} n={o.n_note} titolo="Note e interazioni" testid={`crm-icona-note-${o.id}`}
          onClick={() => nav(`/crm/opportunita/${o.id}?sezione=note`)}><StickyNote className="h-4 w-4" /></Icona>
        <Icona attiva={o.n_attivita > 0} n={o.n_attivita} titolo="Attività da fare" testid={`crm-icona-attivita-${o.id}`}
          onClick={() => nav(`/crm/opportunita/${o.id}?sezione=attivita`)}><CalendarCheck className="h-4 w-4" /></Icona>
        <Icona attiva={!!o.url} titolo={o.url ? "Apri l'URL" : "Nessun URL"} testid={`crm-icona-url-${o.id}`}
          onClick={() => window.open(o.url, "_blank", "noopener,noreferrer")}><Link2 className="h-4 w-4" /></Icona>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" className="flex flex-wrap justify-end gap-1 min-w-[1.5rem]" data-testid={`crm-etichette-${o.id}`}>
            {(o.etichette_dati || []).map((e) => <span key={e.id} className="rounded-full px-2 py-0.5 text-[10px] font-semibold"
              style={stileEtichetta(e.colore)} data-testid={`crm-etichetta-${o.id}-${e.id}`}>{e.nome}</span>)}
            {!o.etichette_dati?.length && <Tag className="h-4 w-4 text-slate-300" />}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
          {!aggiungibili.length && <div className="px-2 py-1 text-xs text-slate-400">Nessuna etichetta</div>}
          {aggiungibili.map((e) => <DropdownMenuCheckboxItem key={e.id} checked={mie.includes(e.id)} onCheckedChange={() => cambia(e.id)}
            data-testid={`crm-etichetta-scelta-${o.id}-${e.id}`}>{e.nome}</DropdownMenuCheckboxItem>)}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
